var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80, _circle81, _circle82, _circle83, _circle84, _circle85, _circle86, _circle87, _circle88, _circle89, _circle90, _circle91, _circle92, _circle93, _circle94, _circle95, _circle96, _circle97, _circle98, _circle99, _circle100, _circle101, _circle102, _circle103, _circle104, _circle105, _circle106, _circle107, _circle108, _circle109, _circle110, _circle111, _circle112, _circle113, _circle114, _circle115, _circle116, _circle117, _circle118, _circle119, _circle120, _circle121, _circle122, _circle123, _circle124, _circle125, _circle126, _circle127, _circle128, _circle129, _circle130, _circle131, _circle132, _circle133, _circle134, _circle135, _circle136, _circle137, _circle138, _circle139, _circle140, _circle141, _circle142, _circle143, _circle144, _circle145, _circle146, _circle147, _circle148, _circle149, _circle150, _circle151, _circle152, _circle153, _circle154, _circle155, _circle156, _circle157, _circle158, _circle159, _circle160, _circle161, _circle162, _circle163, _circle164, _circle165, _circle166, _circle167, _circle168, _circle169, _circle170, _circle171, _circle172, _circle173, _circle174, _circle175, _circle176, _circle177, _circle178, _circle179, _circle180, _circle181, _circle182, _circle183, _circle184, _circle185, _circle186, _circle187, _circle188, _circle189, _circle190, _circle191, _circle192, _circle193, _circle194, _circle195, _circle196, _circle197, _circle198, _circle199, _circle200, _circle201, _circle202, _circle203, _circle204, _circle205, _circle206, _circle207, _circle208, _circle209, _circle210, _circle211, _circle212, _circle213, _circle214, _circle215, _circle216, _circle217, _circle218, _circle219, _circle220, _circle221, _circle222, _circle223, _circle224, _circle225, _circle226, _circle227, _circle228, _circle229, _circle230, _circle231, _circle232, _circle233, _circle234, _circle235, _circle236, _circle237, _circle238, _circle239, _circle240, _circle241, _circle242, _circle243, _circle244, _circle245, _circle246, _circle247, _circle248, _circle249, _circle250, _circle251, _circle252, _circle253, _circle254, _circle255, _circle256, _circle257, _circle258, _circle259, _circle260, _circle261, _circle262, _circle263, _circle264, _circle265, _circle266, _circle267, _circle268, _circle269, _circle270, _circle271, _circle272, _circle273, _circle274, _circle275, _circle276, _circle277, _circle278, _circle279, _circle280, _circle281, _circle282, _circle283, _circle284, _circle285, _circle286, _circle287, _circle288, _circle289, _circle290, _circle291, _circle292, _circle293, _circle294, _circle295, _circle296, _circle297, _circle298, _circle299, _circle300, _circle301, _circle302, _circle303, _circle304, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwiperBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 311,
    height: 330,
    viewBox: "0 0 311 330",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 74.5,
    cy: 2.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.5,
    cy: 106.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.5,
    cy: 54.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.5,
    cy: 158.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.5,
    cy: 28.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.5,
    cy: 132.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.5,
    cy: 80.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.5,
    cy: 184.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.5,
    cy: 15.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.5,
    cy: 119.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.5,
    cy: 67.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.5,
    cy: 171.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.5,
    cy: 41.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.5,
    cy: 145.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.5,
    cy: 93.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.5,
    cy: 197.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 2.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 106.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 54.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 158.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 28.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 132.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 80.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 184.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 15.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 119.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 67.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 171.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 41.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 145.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 93.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 197.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.5,
    cy: 2.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.5,
    cy: 106.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.5,
    cy: 54.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.5,
    cy: 158.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.5,
    cy: 28.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.5,
    cy: 132.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.5,
    cy: 80.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.5,
    cy: 184.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.5,
    cy: 15.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.5,
    cy: 119.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.5,
    cy: 67.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.5,
    cy: 171.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.5,
    cy: 41.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.5,
    cy: 145.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.5,
    cy: 93.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 100.5,
    cy: 197.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.5,
    cy: 2.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.5,
    cy: 106.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.5,
    cy: 54.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.5,
    cy: 158.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.5,
    cy: 28.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.5,
    cy: 132.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.5,
    cy: 80.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.5,
    cy: 184.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.5,
    cy: 15.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.5,
    cy: 119.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.5,
    cy: 67.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.5,
    cy: 171.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.5,
    cy: 41.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.5,
    cy: 145.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.5,
    cy: 93.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 113.5,
    cy: 197.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 2.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 106.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 54.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 158.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 28.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 132.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 80.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 184.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 15.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 119.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 67.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 171.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 41.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 145.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 93.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.5,
    cy: 197.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    cx: 139.5,
    cy: 2.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    cx: 139.5,
    cy: 106.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    cx: 139.5,
    cy: 54.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    cx: 139.5,
    cy: 158.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    cx: 139.5,
    cy: 28.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    cx: 139.5,
    cy: 132.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    cx: 139.5,
    cy: 80.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    cx: 139.5,
    cy: 184.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    cx: 191.5,
    cy: 2.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    cx: 269.5,
    cy: 2.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    cx: 191.5,
    cy: 106.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    cx: 269.5,
    cy: 106.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    cx: 191.5,
    cy: 54.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    cx: 269.5,
    cy: 54.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    cx: 191.5,
    cy: 158.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    cx: 269.5,
    cy: 158.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle97 || (_circle97 = /*#__PURE__*/React.createElement("circle", {
    cx: 191.5,
    cy: 28.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle98 || (_circle98 = /*#__PURE__*/React.createElement("circle", {
    cx: 269.5,
    cy: 28.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle99 || (_circle99 = /*#__PURE__*/React.createElement("circle", {
    cx: 191.5,
    cy: 132.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle100 || (_circle100 = /*#__PURE__*/React.createElement("circle", {
    cx: 269.5,
    cy: 132.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle101 || (_circle101 = /*#__PURE__*/React.createElement("circle", {
    cx: 191.5,
    cy: 80.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle102 || (_circle102 = /*#__PURE__*/React.createElement("circle", {
    cx: 269.5,
    cy: 80.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle103 || (_circle103 = /*#__PURE__*/React.createElement("circle", {
    cx: 191.5,
    cy: 184.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle104 || (_circle104 = /*#__PURE__*/React.createElement("circle", {
    cx: 269.5,
    cy: 184.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle105 || (_circle105 = /*#__PURE__*/React.createElement("circle", {
    cx: 139.5,
    cy: 15.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle106 || (_circle106 = /*#__PURE__*/React.createElement("circle", {
    cx: 139.5,
    cy: 119.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle107 || (_circle107 = /*#__PURE__*/React.createElement("circle", {
    cx: 139.5,
    cy: 67.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle108 || (_circle108 = /*#__PURE__*/React.createElement("circle", {
    cx: 139.5,
    cy: 171.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle109 || (_circle109 = /*#__PURE__*/React.createElement("circle", {
    cx: 139.5,
    cy: 41.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle110 || (_circle110 = /*#__PURE__*/React.createElement("circle", {
    cx: 139.5,
    cy: 145.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle111 || (_circle111 = /*#__PURE__*/React.createElement("circle", {
    cx: 139.5,
    cy: 93.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle112 || (_circle112 = /*#__PURE__*/React.createElement("circle", {
    cx: 139.5,
    cy: 197.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle113 || (_circle113 = /*#__PURE__*/React.createElement("circle", {
    cx: 191.5,
    cy: 15.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle114 || (_circle114 = /*#__PURE__*/React.createElement("circle", {
    cx: 269.5,
    cy: 15.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle115 || (_circle115 = /*#__PURE__*/React.createElement("circle", {
    cx: 191.5,
    cy: 119.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle116 || (_circle116 = /*#__PURE__*/React.createElement("circle", {
    cx: 269.5,
    cy: 119.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle117 || (_circle117 = /*#__PURE__*/React.createElement("circle", {
    cx: 191.5,
    cy: 67.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle118 || (_circle118 = /*#__PURE__*/React.createElement("circle", {
    cx: 269.5,
    cy: 67.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle119 || (_circle119 = /*#__PURE__*/React.createElement("circle", {
    cx: 191.5,
    cy: 171.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle120 || (_circle120 = /*#__PURE__*/React.createElement("circle", {
    cx: 269.5,
    cy: 171.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle121 || (_circle121 = /*#__PURE__*/React.createElement("circle", {
    cx: 191.5,
    cy: 41.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle122 || (_circle122 = /*#__PURE__*/React.createElement("circle", {
    cx: 269.5,
    cy: 41.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle123 || (_circle123 = /*#__PURE__*/React.createElement("circle", {
    cx: 191.5,
    cy: 145.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle124 || (_circle124 = /*#__PURE__*/React.createElement("circle", {
    cx: 269.5,
    cy: 145.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle125 || (_circle125 = /*#__PURE__*/React.createElement("circle", {
    cx: 191.5,
    cy: 93.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle126 || (_circle126 = /*#__PURE__*/React.createElement("circle", {
    cx: 269.5,
    cy: 93.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle127 || (_circle127 = /*#__PURE__*/React.createElement("circle", {
    cx: 191.5,
    cy: 197.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle128 || (_circle128 = /*#__PURE__*/React.createElement("circle", {
    cx: 269.5,
    cy: 197.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle129 || (_circle129 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.5,
    cy: 2.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle130 || (_circle130 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.5,
    cy: 106.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle131 || (_circle131 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.5,
    cy: 54.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle132 || (_circle132 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.5,
    cy: 158.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle133 || (_circle133 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.5,
    cy: 28.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle134 || (_circle134 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.5,
    cy: 132.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle135 || (_circle135 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.5,
    cy: 80.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle136 || (_circle136 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.5,
    cy: 184.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle137 || (_circle137 = /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 2.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle138 || (_circle138 = /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 2.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle139 || (_circle139 = /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 106.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle140 || (_circle140 = /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 106.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle141 || (_circle141 = /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 54.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle142 || (_circle142 = /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 54.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle143 || (_circle143 = /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 158.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle144 || (_circle144 = /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 158.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle145 || (_circle145 = /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 28.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle146 || (_circle146 = /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 28.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle147 || (_circle147 = /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 132.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle148 || (_circle148 = /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 132.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle149 || (_circle149 = /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 80.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle150 || (_circle150 = /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 80.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle151 || (_circle151 = /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 184.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle152 || (_circle152 = /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 184.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle153 || (_circle153 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.5,
    cy: 15.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle154 || (_circle154 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.5,
    cy: 119.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle155 || (_circle155 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.5,
    cy: 67.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle156 || (_circle156 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.5,
    cy: 171.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle157 || (_circle157 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.5,
    cy: 41.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle158 || (_circle158 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.5,
    cy: 145.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle159 || (_circle159 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.5,
    cy: 93.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle160 || (_circle160 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.5,
    cy: 197.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle161 || (_circle161 = /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 15.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle162 || (_circle162 = /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 15.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle163 || (_circle163 = /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 119.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle164 || (_circle164 = /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 119.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle165 || (_circle165 = /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 67.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle166 || (_circle166 = /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 67.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle167 || (_circle167 = /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 171.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle168 || (_circle168 = /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 171.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle169 || (_circle169 = /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 41.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle170 || (_circle170 = /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 41.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle171 || (_circle171 = /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 145.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle172 || (_circle172 = /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 145.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle173 || (_circle173 = /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 93.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle174 || (_circle174 = /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 93.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle175 || (_circle175 = /*#__PURE__*/React.createElement("circle", {
    cx: 204.5,
    cy: 197.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle176 || (_circle176 = /*#__PURE__*/React.createElement("circle", {
    cx: 282.5,
    cy: 197.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle177 || (_circle177 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.5,
    cy: 2.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle178 || (_circle178 = /*#__PURE__*/React.createElement("circle", {
    cx: 243.5,
    cy: 2.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle179 || (_circle179 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.5,
    cy: 106.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle180 || (_circle180 = /*#__PURE__*/React.createElement("circle", {
    cx: 243.5,
    cy: 106.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle181 || (_circle181 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.5,
    cy: 54.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle182 || (_circle182 = /*#__PURE__*/React.createElement("circle", {
    cx: 243.5,
    cy: 54.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle183 || (_circle183 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.5,
    cy: 158.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle184 || (_circle184 = /*#__PURE__*/React.createElement("circle", {
    cx: 243.5,
    cy: 158.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle185 || (_circle185 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.5,
    cy: 28.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle186 || (_circle186 = /*#__PURE__*/React.createElement("circle", {
    cx: 243.5,
    cy: 28.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle187 || (_circle187 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.5,
    cy: 132.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle188 || (_circle188 = /*#__PURE__*/React.createElement("circle", {
    cx: 243.5,
    cy: 132.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle189 || (_circle189 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.5,
    cy: 80.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle190 || (_circle190 = /*#__PURE__*/React.createElement("circle", {
    cx: 243.5,
    cy: 80.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle191 || (_circle191 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.5,
    cy: 184.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle192 || (_circle192 = /*#__PURE__*/React.createElement("circle", {
    cx: 243.5,
    cy: 184.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle193 || (_circle193 = /*#__PURE__*/React.createElement("circle", {
    cx: 217.5,
    cy: 2.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle194 || (_circle194 = /*#__PURE__*/React.createElement("circle", {
    cx: 295.5,
    cy: 2.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle195 || (_circle195 = /*#__PURE__*/React.createElement("circle", {
    cx: 217.5,
    cy: 106.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle196 || (_circle196 = /*#__PURE__*/React.createElement("circle", {
    cx: 295.5,
    cy: 106.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle197 || (_circle197 = /*#__PURE__*/React.createElement("circle", {
    cx: 217.5,
    cy: 54.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle198 || (_circle198 = /*#__PURE__*/React.createElement("circle", {
    cx: 295.5,
    cy: 54.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle199 || (_circle199 = /*#__PURE__*/React.createElement("circle", {
    cx: 217.5,
    cy: 158.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle200 || (_circle200 = /*#__PURE__*/React.createElement("circle", {
    cx: 295.5,
    cy: 158.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle201 || (_circle201 = /*#__PURE__*/React.createElement("circle", {
    cx: 217.5,
    cy: 28.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle202 || (_circle202 = /*#__PURE__*/React.createElement("circle", {
    cx: 295.5,
    cy: 28.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle203 || (_circle203 = /*#__PURE__*/React.createElement("circle", {
    cx: 217.5,
    cy: 132.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle204 || (_circle204 = /*#__PURE__*/React.createElement("circle", {
    cx: 295.5,
    cy: 132.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle205 || (_circle205 = /*#__PURE__*/React.createElement("circle", {
    cx: 217.5,
    cy: 80.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle206 || (_circle206 = /*#__PURE__*/React.createElement("circle", {
    cx: 295.5,
    cy: 80.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle207 || (_circle207 = /*#__PURE__*/React.createElement("circle", {
    cx: 217.5,
    cy: 184.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle208 || (_circle208 = /*#__PURE__*/React.createElement("circle", {
    cx: 295.5,
    cy: 184.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle209 || (_circle209 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.5,
    cy: 15.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle210 || (_circle210 = /*#__PURE__*/React.createElement("circle", {
    cx: 243.5,
    cy: 15.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle211 || (_circle211 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.5,
    cy: 119.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle212 || (_circle212 = /*#__PURE__*/React.createElement("circle", {
    cx: 243.5,
    cy: 119.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle213 || (_circle213 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.5,
    cy: 67.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle214 || (_circle214 = /*#__PURE__*/React.createElement("circle", {
    cx: 243.5,
    cy: 67.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle215 || (_circle215 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.5,
    cy: 171.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle216 || (_circle216 = /*#__PURE__*/React.createElement("circle", {
    cx: 243.5,
    cy: 171.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle217 || (_circle217 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.5,
    cy: 41.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle218 || (_circle218 = /*#__PURE__*/React.createElement("circle", {
    cx: 243.5,
    cy: 41.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle219 || (_circle219 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.5,
    cy: 145.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle220 || (_circle220 = /*#__PURE__*/React.createElement("circle", {
    cx: 243.5,
    cy: 145.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle221 || (_circle221 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.5,
    cy: 93.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle222 || (_circle222 = /*#__PURE__*/React.createElement("circle", {
    cx: 243.5,
    cy: 93.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle223 || (_circle223 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.5,
    cy: 197.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle224 || (_circle224 = /*#__PURE__*/React.createElement("circle", {
    cx: 243.5,
    cy: 197.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle225 || (_circle225 = /*#__PURE__*/React.createElement("circle", {
    cx: 217.5,
    cy: 15.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle226 || (_circle226 = /*#__PURE__*/React.createElement("circle", {
    cx: 295.5,
    cy: 15.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle227 || (_circle227 = /*#__PURE__*/React.createElement("circle", {
    cx: 217.5,
    cy: 119.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle228 || (_circle228 = /*#__PURE__*/React.createElement("circle", {
    cx: 295.5,
    cy: 119.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle229 || (_circle229 = /*#__PURE__*/React.createElement("circle", {
    cx: 217.5,
    cy: 67.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle230 || (_circle230 = /*#__PURE__*/React.createElement("circle", {
    cx: 295.5,
    cy: 67.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle231 || (_circle231 = /*#__PURE__*/React.createElement("circle", {
    cx: 217.5,
    cy: 171.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle232 || (_circle232 = /*#__PURE__*/React.createElement("circle", {
    cx: 295.5,
    cy: 171.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle233 || (_circle233 = /*#__PURE__*/React.createElement("circle", {
    cx: 217.5,
    cy: 41.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle234 || (_circle234 = /*#__PURE__*/React.createElement("circle", {
    cx: 295.5,
    cy: 41.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle235 || (_circle235 = /*#__PURE__*/React.createElement("circle", {
    cx: 217.5,
    cy: 145.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle236 || (_circle236 = /*#__PURE__*/React.createElement("circle", {
    cx: 295.5,
    cy: 145.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle237 || (_circle237 = /*#__PURE__*/React.createElement("circle", {
    cx: 217.5,
    cy: 93.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle238 || (_circle238 = /*#__PURE__*/React.createElement("circle", {
    cx: 295.5,
    cy: 93.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle239 || (_circle239 = /*#__PURE__*/React.createElement("circle", {
    cx: 217.5,
    cy: 197.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle240 || (_circle240 = /*#__PURE__*/React.createElement("circle", {
    cx: 295.5,
    cy: 197.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle241 || (_circle241 = /*#__PURE__*/React.createElement("circle", {
    cx: 178.5,
    cy: 2.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle242 || (_circle242 = /*#__PURE__*/React.createElement("circle", {
    cx: 256.5,
    cy: 2.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle243 || (_circle243 = /*#__PURE__*/React.createElement("circle", {
    cx: 178.5,
    cy: 106.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle244 || (_circle244 = /*#__PURE__*/React.createElement("circle", {
    cx: 256.5,
    cy: 106.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle245 || (_circle245 = /*#__PURE__*/React.createElement("circle", {
    cx: 178.5,
    cy: 54.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle246 || (_circle246 = /*#__PURE__*/React.createElement("circle", {
    cx: 256.5,
    cy: 54.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle247 || (_circle247 = /*#__PURE__*/React.createElement("circle", {
    cx: 178.5,
    cy: 158.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle248 || (_circle248 = /*#__PURE__*/React.createElement("circle", {
    cx: 256.5,
    cy: 158.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle249 || (_circle249 = /*#__PURE__*/React.createElement("circle", {
    cx: 178.5,
    cy: 28.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle250 || (_circle250 = /*#__PURE__*/React.createElement("circle", {
    cx: 256.5,
    cy: 28.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle251 || (_circle251 = /*#__PURE__*/React.createElement("circle", {
    cx: 178.5,
    cy: 132.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle252 || (_circle252 = /*#__PURE__*/React.createElement("circle", {
    cx: 256.5,
    cy: 132.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle253 || (_circle253 = /*#__PURE__*/React.createElement("circle", {
    cx: 178.5,
    cy: 80.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle254 || (_circle254 = /*#__PURE__*/React.createElement("circle", {
    cx: 256.5,
    cy: 80.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle255 || (_circle255 = /*#__PURE__*/React.createElement("circle", {
    cx: 178.5,
    cy: 184.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle256 || (_circle256 = /*#__PURE__*/React.createElement("circle", {
    cx: 256.5,
    cy: 184.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle257 || (_circle257 = /*#__PURE__*/React.createElement("circle", {
    cx: 230.5,
    cy: 2.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle258 || (_circle258 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.5,
    cy: 2.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle259 || (_circle259 = /*#__PURE__*/React.createElement("circle", {
    cx: 230.5,
    cy: 106.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle260 || (_circle260 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.5,
    cy: 106.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle261 || (_circle261 = /*#__PURE__*/React.createElement("circle", {
    cx: 230.5,
    cy: 54.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle262 || (_circle262 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.5,
    cy: 54.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle263 || (_circle263 = /*#__PURE__*/React.createElement("circle", {
    cx: 230.5,
    cy: 158.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle264 || (_circle264 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.5,
    cy: 158.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle265 || (_circle265 = /*#__PURE__*/React.createElement("circle", {
    cx: 230.5,
    cy: 28.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle266 || (_circle266 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.5,
    cy: 28.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle267 || (_circle267 = /*#__PURE__*/React.createElement("circle", {
    cx: 230.5,
    cy: 132.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle268 || (_circle268 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.5,
    cy: 132.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle269 || (_circle269 = /*#__PURE__*/React.createElement("circle", {
    cx: 230.5,
    cy: 80.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle270 || (_circle270 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.5,
    cy: 80.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle271 || (_circle271 = /*#__PURE__*/React.createElement("circle", {
    cx: 230.5,
    cy: 184.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle272 || (_circle272 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.5,
    cy: 184.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle273 || (_circle273 = /*#__PURE__*/React.createElement("circle", {
    cx: 178.5,
    cy: 15.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle274 || (_circle274 = /*#__PURE__*/React.createElement("circle", {
    cx: 256.5,
    cy: 15.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle275 || (_circle275 = /*#__PURE__*/React.createElement("circle", {
    cx: 178.5,
    cy: 119.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle276 || (_circle276 = /*#__PURE__*/React.createElement("circle", {
    cx: 256.5,
    cy: 119.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle277 || (_circle277 = /*#__PURE__*/React.createElement("circle", {
    cx: 178.5,
    cy: 67.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle278 || (_circle278 = /*#__PURE__*/React.createElement("circle", {
    cx: 256.5,
    cy: 67.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle279 || (_circle279 = /*#__PURE__*/React.createElement("circle", {
    cx: 178.5,
    cy: 171.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle280 || (_circle280 = /*#__PURE__*/React.createElement("circle", {
    cx: 256.5,
    cy: 171.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle281 || (_circle281 = /*#__PURE__*/React.createElement("circle", {
    cx: 178.5,
    cy: 41.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle282 || (_circle282 = /*#__PURE__*/React.createElement("circle", {
    cx: 256.5,
    cy: 41.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle283 || (_circle283 = /*#__PURE__*/React.createElement("circle", {
    cx: 178.5,
    cy: 145.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle284 || (_circle284 = /*#__PURE__*/React.createElement("circle", {
    cx: 256.5,
    cy: 145.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle285 || (_circle285 = /*#__PURE__*/React.createElement("circle", {
    cx: 178.5,
    cy: 93.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle286 || (_circle286 = /*#__PURE__*/React.createElement("circle", {
    cx: 256.5,
    cy: 93.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle287 || (_circle287 = /*#__PURE__*/React.createElement("circle", {
    cx: 178.5,
    cy: 197.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle288 || (_circle288 = /*#__PURE__*/React.createElement("circle", {
    cx: 256.5,
    cy: 197.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle289 || (_circle289 = /*#__PURE__*/React.createElement("circle", {
    cx: 230.5,
    cy: 15.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle290 || (_circle290 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.5,
    cy: 15.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle291 || (_circle291 = /*#__PURE__*/React.createElement("circle", {
    cx: 230.5,
    cy: 119.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle292 || (_circle292 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.5,
    cy: 119.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle293 || (_circle293 = /*#__PURE__*/React.createElement("circle", {
    cx: 230.5,
    cy: 67.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle294 || (_circle294 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.5,
    cy: 67.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle295 || (_circle295 = /*#__PURE__*/React.createElement("circle", {
    cx: 230.5,
    cy: 171.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle296 || (_circle296 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.5,
    cy: 171.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle297 || (_circle297 = /*#__PURE__*/React.createElement("circle", {
    cx: 230.5,
    cy: 41.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle298 || (_circle298 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.5,
    cy: 41.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle299 || (_circle299 = /*#__PURE__*/React.createElement("circle", {
    cx: 230.5,
    cy: 145.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle300 || (_circle300 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.5,
    cy: 145.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle301 || (_circle301 = /*#__PURE__*/React.createElement("circle", {
    cx: 230.5,
    cy: 93.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle302 || (_circle302 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.5,
    cy: 93.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle303 || (_circle303 = /*#__PURE__*/React.createElement("circle", {
    cx: 230.5,
    cy: 197.5,
    r: 2.5,
    fill: "#FE8700"
  })), _circle304 || (_circle304 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.5,
    cy: 197.5,
    r: 2.5,
    fill: "#FE8700"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M273 193.5C273 220.497 264.994 246.888 249.996 269.335C234.997 291.783 213.678 309.278 188.736 319.61C163.794 329.941 136.349 332.644 109.87 327.377C83.3918 322.11 59.0698 309.11 39.9799 290.02L136.5 193.5H273Z",
    fill: "#FFDA44"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwiperBackground);
export default __webpack_public_path__ + "static/media/swiperBackground.6a9c573121ad513bbac563296c3d65cb.svg";
export { ForwardRef as ReactComponent };